var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdaptiveWidth",style:({
    '--tiny': _vm.tiny,
    '--small': _vm.small,
    '--medium': _vm.medium,
    '--large': _vm.large,
    '--xlarge': _vm.xlarge,
    '--huge': _vm.huge,
    '--width': _vm.width ? _vm.width : '100%',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }